<template>
  <div class="">
    <div class="content-start">

      <div class="flex">
        <div class="flex-1 mr-1" v-if="customer.firstName == null">
          <label class="block text-sm ">First Name</label>
          <input aria-label="First Name" type="text" required
                 v-model="firstName"
                 class="appearance-none border w-full py-2 px-3 text-gray-700 mb-3 leading-tight focus:outline-none"
                 placeholder="First Name"/>
        </div>
        <div class="flex-1 ml-1" v-if="customer.lastName == null">
          <label class="block text-sm ">Last Name</label>
          <input aria-label="Last Name" type="text" required v-model="lastName"
                 class="appearance-none border w-full py-2 px-3 text-gray-700 mb-3 leading-tight focus:outline-none"
                 placeholder="Last Name"/>
        </div>
      </div>
      <div class="" v-if="customer.emailAddress == null">
        <label class="block text-sm leading-5 ">Email Address</label>
        <input aria-label="Email Address" name="email_address" type="email" required
               v-model="emailAddress"
               class="appearance-none border w-full py-2 px-3 text-gray-700 mb-3 leading-tight focus:outline-none"
               placeholder="Email Address"/>
      </div>
      <div class="" v-if="customer.phoneNumber == null">
        <label class="block text-sm leading-5 ">Phone Number</label>
        <input aria-label="Phone Number" type="tel" required v-model="phoneNumber"
               class="appearance-none border w-full py-2 px-3 text-gray-700 mb-3 leading-tight focus:outline-none"
               placeholder="Phone Number"/>
      </div>
      <div class="" v-if="verifyNumber">
        <label class="block text-sm leading-5 ">Phone verification code</label>
        <input aria-label="Phone verification code" name="phone_verification" type="text" required
               v-model="phoneVerificationCode"
               class="appearance-none border w-full py-2 px-3 text-gray-700 mb-3 leading-tight focus:outline-none "
               placeholder="Phone verification code"/>
      </div>
      <div class="" v-if="enterVoucher">
        <label class="block text-sm leading-5 ">Voucher code</label>
        <input aria-label="Voucher code" name="phone_verification" type="text" required
               v-model="voucherCode"
               class="appearance-none border w-full py-2 px-3 text-gray-700 mb-3 leading-tight focus:outline-none"
               placeholder="Voucher code"/>
      </div>
    </div>
    <div class="text-center">
      <button v-on:click="connect"
              class="mx-auto w-full lg:mx-0 text-white font-bold focus:bg-teal-800 shadow bg-teal-600 mt-3 py-3 px-8 focus:outline-none shadow-md uppercase">
        Sign up
      </button>
    </div>
  </div>
</template>

<script>

export default {
  name: "SignUp",
  components: {},
  props: {
    customer: Object,
    token: String
  },
  data() {
    return {
      errors: [],
      emailAddress: '',
      phoneNumber: '07',
      voucherCode: '07',
      phoneVerificationCode: '07',
      firstName: '',
      lastName: '',
      password: '',
      verifyNumber: false,
      enterVoucher: false,
    }
  },
  watch: {
    errors: function (errors) {
      this.$root.$emit('alert_error', errors);
    }
  },
  methods: {
    connect: function () {
      this.loading = true;
      this.errors = [];
      if (this.customer.emailAddress == null && (this.emailAddress == null || this.emailAddress === ''))
        this.errors.push("Email address is required.");
      if (this.customer.phoneNumber == null && (this.phoneNumber == null || this.phoneNumber === ''))
        this.errors.push("Phone number is required.");
      if (this.errors.length > 0) {
        this.loading = false;
        return;
      }

      this.axios.post(process.env.VUE_APP_SPLASH_URL + "/connect/auto",
          {
            token: this.token,
            first_name: this.customer.firstName || this.firstName,
            middle_name: this.customer.middleName || this.middleName,
            last_name: this.customer.lastName || this.lastName,
            email_address: this.customer.emailAddress || this.emailAddress,
            phone_number: this.customer.phoneNumber || this.phoneNumber,
            mode: "SIGNUP",
          }
      ).then((response) => {
        if (response.data.redirect_to)
          window.location.href = response.data.redirect_to
        else
          alert(response.data.error)
      });
    }
  }
}
</script>

<style scoped>

</style>